<template>
  <div
    class="t-course-list"
    :class="{
      'electron-t-course-list': isElectron,
    }"
  >
    <ul v-if="courseList.length" class="course-list-wrap">
      <li
        class="my-course-crad"
        @click="showDetail(item.course_id)"
        v-for="item in courseList"
        :key="item.course_id"
      >
        <div class="cover">
          <img :src="processImageUrl(item.cover_url, 600)" alt="" />
        </div>
        <div class="course-info">
          <p class="name">
            {{ item.course_name }}
          </p>
          <p class="lesson-num">
            课时数：<span>{{ item.lesson_count }}课时</span>
          </p>
        </div>
      </li>
    </ul>
    <el-empty
      v-else
      description="暂无内容"
      :image="require('@/assets/img/live-list/empty.png')"
    ></el-empty>
  </div>
</template>

<script>
import moment from "moment";
import { getMyCourseList } from "@saas/service-api/src/teacher";
import { processImageUrl } from "@saas/components/src/utils/utils";
export default {
  data: function () {
    return {
      moment,
      courseList: [],
      page_no: 1,
      page_size: 18,
      noMore: false, //没有更多
      loading: false, //加载数据中
      isElectron: window.isElectron,
    };
  },
  created() {
    this.apiGetCourseList();
  },
  mounted() {
    this.$nextTick(() => {
      if (window.isElectron) {
        let elMain = document.getElementById("electron-main");
        if (!elMain) return;
        elMain.addEventListener("scroll", this.handleElScrollFn, true);
      } else {
        window.addEventListener("scroll", this.scrollFn, true); //监听页面滚动
      }
    });
  },
  beforeDestroy() {
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.handleElScrollFn, true);
    } else {
      window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
    }
  },
  methods: {
    processImageUrl,
    apiGetCourseList() {
      let params = {
        page_no: this.page_no,
        page_size: this.page_size,
      };
      getMyCourseList(params).then((res) => {
        if (res.code === 1) {
          let arr = res.data?.list || [];
          this.courseList = this.courseList.concat(arr);
          if (this.courseList.length === res.data.total) {
            this.noMore = true;
          }
        } else {
          this.$message.error(res.message);
        }
        this.loading = false;
      });
    },
    handleElScrollFn(event) {
      if (this.loading || this.noMore) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.loading = true;
        this.page_no++;
        this.apiGetCourseList();
      }
    },
    scrollFn() {
      if (this.loading) return false;
      //获取网页的总高度
      var htmlHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      //clientHeight是网页在浏览器中的可视高度
      var clientHeight =
        document.body.clientHeight || document.documentElement.clientHeight;
      //scrollTop是浏览器滚动条的top位置
      var scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      //判断到底部了
      if (scrollTop + clientHeight > htmlHeight - 100) {
        if (!this.noMore) {
          this.loading = true;
          this.page_no++;
          this.apiGetCourseList();
        } else {
          window.removeEventListener("scroll", this.scrollFn, true); //销毁滚动事件
        }
      }
    },
    showDetail(id) {
      this.$router.push({ name: "TCourseDetail", params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.t-course-list {
  min-height: calc(100vh - 110px);
  .course-list-wrap {
    display: flex;
    flex-wrap: wrap;
  }
  .my-course-crad {
    margin: 0 30px 30px 0;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
  .my-course-crad {
    &:hover {
      transition: all 0.3s ease;
      transform: translateY(-5px);
      box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
      .cover img {
        transform: scale(1.2) rotate(0.02deg);
      }
    }
    transition: all 0.3s ease;
    width: 330px;
    height: 296px;
    background: var(--card-bg, #ffffff);
    border: 1px solid var(--border-subtle, transparent);
    border-radius: 24px;
    cursor: pointer;
    padding: 16px;
    display: flex;
    flex-direction: column;
    .cover {
      width: 298px;
      height: 168px;
      border-radius: 16px;
      margin-bottom: 14px;
      overflow: hidden;
    }
    .cover img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: 0.3s ease-in-out;
      will-change: transform;
      transform: scale(1) rotate(0.02deg);
    }
    .course-info {
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-weight: 500;
        font-size: 18px;
        color: var(--text-primary, #{$saas-text-color});
        line-height: 28px;
        word-break: break-all;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .lesson-num {
        font-weight: 400;
        font-size: 14px;
        color: var(--text-secondary, #747573);
        line-height: 20px;
      }
    }
  }
  .el-empty {
    height: 400px;
    background: var(--card-bg, #fff);
    color: var(--text-primary, #{$saas-text-color});
    border-radius: 24px;
  }
}

// 客户端
.t-course-list.electron-t-course-list {
  .my-course-crad {
    margin: 0 15px 15px 0;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .my-course-crad {
    width: 260px;
    height: 240px;
    border-radius: 18px;
    padding: 10px;
    .cover {
      width: 240px;
      height: 135px;
      border-radius: 16px;
      margin-bottom: 12px;
    }
    .course-info {
      .name {
        font-size: 14px;
        line-height: 20px;
      }
      .lesson-num {
        margin-bottom: 6px;
        .white-btn {
          height: 22px;
          line-height: 1;
          border-radius: 10px;
          font-size: 12px;
        }
      }
      .lesson-num,
      .time {
        font-size: 12px;
        line-height: 17px;
      }
    }
  }
}
</style>
